import clsx from 'clsx'
import moment from 'moment';
import React, { useState } from 'react'
import { ISingleMessage } from './chat-box';
import { toast } from 'react-toastify';
import { ParseErrors } from '../../utils/ParseErrors';
import axiosInstance from '../../utils/axiosInstance';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faCheckDouble, faCircleNotch, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

interface IChatMessage {
    item: ISingleMessage
    showMessage: boolean
}

const ChatMessage: React.FC<IChatMessage> = ({ item: itemData, showMessage }) => {
    const [item, setItem] = useState<ISingleMessage>(itemData)
    const [loading, setLoading] = useState<boolean>(false)
    let isSender = item.type === "dashboard"


    const ToggleMessageFromPortal = async () => {
        setLoading(true)
        try {
            const res = await axiosInstance.post(`/message/toggle/${item?.id}`)
            toast.success(res.data.data)
            setItem((prev) => ({ ...prev, hideFromPortal: !prev.hideFromPortal }))
            setLoading(false)
        } catch (error) {
            toast.error(ParseErrors(error))
            console.log(error)
            setLoading(false)
        }
    }

    return (
        <div className={clsx("w-full flex flex-col items-start mb-4", isSender && "items-end", item.hideFromPortal && "opacity-60")}>
            <div className={clsx('flex items-center gap-2 max-w-[80%] smallTablet:max-w-[85%] smallTablet:gap-1 group', isSender && "flex-row-reverse")}>
                <div
                    className={clsx(
                        "px-4 py-2.5 text-[13px] font-medium leading-relaxed smallTablet:min-w-0 smallTablet:px-3 smallTablet:break-words smallTablet:[overflow-wrap:anywhere]",
                        isSender
                            ? "bg-gradient-to-r from-accent to-accent-bright text-white rounded-2xl rounded-br-md shadow-glow-sm"
                            : "bg-surface border border-edge text-text-primary rounded-2xl rounded-bl-md"
                    )}
                >
                    {item?.message}
                </div>

                <button
                    disabled={loading}
                    title={item?.hideFromPortal ? "Show to customer" : "Hide from customer"}
                    className='h-7 w-7 shrink-0 rounded-lg flex items-center justify-center text-light-gray hover:text-text-primary hover:bg-overlay opacity-0 group-hover:opacity-100 smallTablet:opacity-60 disabled:cursor-wait transition-all duration-200'
                    onClick={ToggleMessageFromPortal}
                >
                    <FontAwesomeIcon
                        icon={loading ? faCircleNotch : item?.hideFromPortal ? faEye : faEyeSlash}
                        className={clsx('text-[12px]', loading && 'fa-spin')}
                    />
                </button>
            </div>

            <div className={clsx('flex items-center gap-1.5 mt-1 px-1', isSender && "flex-row-reverse")}>
                {!showMessage && (
                    <p className='text-[11px] font-medium text-light-gray tabular-nums'>
                        {moment(item?.createdAt).format("DD MMM YYYY · HH:mm")}
                    </p>
                )}
                {isSender ? (
                    <FontAwesomeIcon
                        icon={item?.isRead ? faCheckDouble : faCheck}
                        title={item?.isRead ? "Read" : "Sent"}
                        className={clsx("text-[10px]", item?.isRead ? "text-emerald-500" : "text-light-gray")}
                    />
                ) : null}
                {item.hideFromPortal ? (
                    <span className='text-[10px] font-semibold uppercase tracking-[0.08em] text-light-gray'>
                        Hidden
                    </span>
                ) : null}
            </div>
        </div>
    )
}

export default ChatMessage
